<ng-container *ngIf="!newFormField; else new">
  <div *ngIf="type !== types.hidden" [class.invalid]="isErrorVisible" [class]="fieldClass"
       [class.invalid-field-animation]="clientValidationAnimation"
       [class.label-visible]="labelIsVisible">
    <ng-container *ngTemplateOutlet="formFieldContent"></ng-container>
  </div>
</ng-container>

<ng-template #new>
  <div *ngIf="type !== types.hidden" [class.invalid]="isErrorVisible" class="form-field"
       [class.invalid-field-animation]="clientValidationAnimation">
    <ng-container *ngTemplateOutlet="formFieldContent"></ng-container>
  </div>
</ng-template>


<ng-template #formFieldContent>
  <ng-content></ng-content>

  <ng-container *ngIf="isErrorVisible">
    <span class="error-input" *ngFor="let key of errorKeys">
      <span class="error-input__content"
            *ngIf="errors[key].tMessage || (errorTexts && errorTexts[key]) || errors[key].error"
            [innerHTML]="errors[key].tMessage || (errorTexts && errorTexts[key]) || errors[key].error | translate: errorParams"></span>
    </span>
  </ng-container>
</ng-template>
